<template>
  <div class="pa-3 pa-md-6 pa-lg-12 text-h5">
    <div class="container">

      <RessourceInfoBulle class="text-h5" code="CF-DIV-1" />
      <RessourceInfoBulle class="text-h5" code="CF-DIV-2" />
      <RessourceInfoBulle class="text-h5" code="CF-DIV-3" />

    </div>
  </div>
</template>
<script>
import { getExtranetUrl } from "@/utils/stringUtils"
import FormulaireMixin from "@/mixins/formulaireMixin"
import ParamFormulaire from "@/mixins/paramFormulaire"

export default {
  mixins: [FormulaireMixin, ParamFormulaire],
  data() {
    return {
      urlEspaceFormationLara: getExtranetUrl(process.env.VUE_APP_FORMATION_XTRANET),
      urlFactures: getExtranetUrl(process.env.VUE_APP_FACTURES_XTRANET),
    }
  },
  async mounted() {
    await this.loadParams(this.$paramFormulaire.codeFormulaireConfirmation)
  },
}
</script>
